import React, { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { 
  Home, Lightbulb, Star, ChevronRight, 
  CheckCircle2, AlertTriangle, Globe
} from 'lucide-react';

const airlineTips = [
  {
    id: 'thy',
    name: 'Türk Hava Yolları',
    emoji: '🇹🇷',
    color: 'from-red-500 to-rose-600',
    slogan: 'Widen Your World',
    keyFacts: [
      '126+ ülke, 340+ destinasyon',
      'Dünyanın en çok ülkesine uçan havayolu',
      '5 yıldızlı hizmet anlayışı',
      'İstanbul hub - dünyanın merkezi'
    ],
    tips: [
      { title: 'Türk Misafirperverliği', desc: 'THY\'nin farkı Türk misafirperverliği. Bunu vurgulayın.' },
      { title: 'Video Mülakat', desc: '5 soruluk video mülakat var. Her soru için 60-90 saniye.' },
      { title: 'Kurul Mülakatı', desc: 'Son aşama çok kritik. 3-4 jüri olacak. Hepsine göz teması kurun.' },
      { title: 'İngilizce Seviye', desc: 'B2 ve üzeri bekleniyor. Akıcı konuşma önemli.' },
      { title: 'Esneklik', desc: 'İstanbul dışı üslere açık olun. Ankara, İzmir, Antalya.' }
    ],
    doNot: [
      'THY\'yi sadece "büyük" diye övmeyin - farkını açıklayın',
      'Rakip havayolları kötülemeyin',
      'Maaş ve yan haklar sormayın (ilk mülakattta)'
    ]
  },
  {
    id: 'pegasus',
    name: 'Pegasus Airlines',
    emoji: '🟡',
    color: 'from-yellow-500 to-orange-500',
    slogan: 'Herkes Uçabilir',
    keyFacts: [
      'Türkiye\'nin en büyük low-cost havayolu',
      'Sabiha Gökçen merkez',
      '25 dakika turnaround time',
      'Genç ve dinamik ekip'
    ],
    tips: [
      { title: 'Low-Cost Felsefe', desc: 'Verimlilik = Düşük maliyet = Uygun fiyat. Bu döngüyü bilin.' },
      { title: 'Hız Önemli', desc: 'Quick turnaround kritik. Hızlı ve verimli çalışmayı vurgulayın.' },
      { title: 'Dinamizm', desc: 'Genç, enerjik, esnek adaylar tercih edilir.' },
      { title: 'Operasyonel Focus', desc: 'On-time performance (dakiklik) Pegasus için önemli.' },
      { title: 'Müşteri Dengesi', desc: 'Fiyat/performans dengesi - hizmet kalitesini koruyarak maliyet düşürmek.' }
    ],
    doNot: [
      'Low-cost\'u "düşük kalite" olarak yorumlamayın',
      'THY ile kıyaslamayın (her ikisi de değerli)',
      'Hızlı tempo size uygun değilse başvurmayın'
    ]
  },
  {
    id: 'sunexpress',
    name: 'SunExpress',
    emoji: '☀️',
    color: 'from-amber-400 to-yellow-500',
    slogan: 'Smile High Club',
    keyFacts: [
      'THY + Lufthansa ortak girişimi',
      'Antalya ve İzmir merkez',
      'Tatil destinasyonları odaklı',
      'Almanya-Türkiye hatları güçlü'
    ],
    tips: [
      { title: 'Tatil Ruhu', desc: 'Yolcular tatilciler - neşeli, sabırlı olmak önemli.' },
      { title: 'Ortaklık Avantajı', desc: 'THY + Lufthansa kalitesi. İki kültürün harmanı.' },
      { title: 'Rahat Ortam', desc: 'Mülakat ortamı genelde daha rahat. Samimi olun.' },
      { title: 'Dil Becerisi', desc: 'Almanca artı puan. Türkçe-İngilizce yeterli.' },
      { title: 'Bölgesel Bilgi', desc: 'Antalya/İzmir bölgesini, turistik yerleri bilin.' }
    ],
    doNot: [
      'Sadece yazlık şirket olarak görmeyin',
      'Alman ortaklığını küçümsemeyin',
      'Tatil havasında çalışmayı hafife almayın'
    ]
  },
  {
    id: 'emirates',
    name: 'Emirates',
    emoji: '🇦🇪',
    color: 'from-red-600 to-red-800',
    slogan: 'Fly Better',
    keyFacts: [
      'Dünyanın en büyük A380 filosu',
      'Dubai (DXB) merkez',
      '150+ destinasyon',
      'Premium ve lüks hizmet'
    ],
    tips: [
      { title: 'Dubai Relocation', desc: 'Kesinlikle "Evet, Dubai\'de yaşamaya hazırım" deyin. Tereddüt = Eleme.' },
      { title: 'Open Day Format', desc: 'Tek günde CV drop + grup + final. Hepsine hazır gelin.' },
      { title: 'Grooming', desc: 'Emirates grooming standartları çok yüksek. Mükemmel görünüm şart.' },
      { title: 'İngilizce', desc: 'Native seviye beklenir. Aksan değil, akıcılık önemli.' },
      { title: 'Global Bakış', desc: 'Farklı kültürlerle çalışma isteği ve deneyimi vurgulayın.' }
    ],
    doNot: [
      '"Dubai\'de ne kadar kalacağım?" diye sormayın',
      'Maaş pazarlığı yapmayın (standart paket var)',
      'Aileden uzak kalma endişesi göstermeyin'
    ]
  },
  {
    id: 'qatar',
    name: 'Qatar Airways',
    emoji: '🇶🇦',
    color: 'from-purple-700 to-purple-900',
    slogan: 'Going Places Together',
    keyFacts: [
      'World\'s Best Airline ödüllü',
      'Doha (DOH) merkez',
      '5 yıldızlı Skytrax',
      'QSuite iş sınıfı'
    ],
    tips: [
      { title: 'Ödüller', desc: '"World\'s Best Airline" - bu ödülü ve nedenini bilin.' },
      { title: 'Reach Test', desc: '212 cm\'ye uzanma testi var. Hazırlıklı olun.' },
      { title: 'Doha Yaşamı', desc: 'Doha hakkında araştırma yapın. Yaşam koşullarını bilin.' },
      { title: 'Kültürel Farkındalık', desc: 'Orta Doğu kültürüne saygı ve farkındalık önemli.' },
      { title: 'Premium Hizmet', desc: '5 yıldız = detaylara dikkat. Mükemmeliyetçiliği vurgulayın.' }
    ],
    doNot: [
      'Katar\'ı Birleşik Arap Emirlikleri ile karıştırmayın',
      'Politik konulara girmeyin',
      'Diğer Körfez havayollarıyla kıyaslamayın'
    ]
  },
  {
    id: 'anadolujet',
    name: 'AnadoluJet',
    emoji: '✈️',
    color: 'from-blue-600 to-blue-800',
    slogan: 'THY Grubu',
    keyFacts: [
      'THY iştiraki',
      'İç hat ve kısa mesafe',
      'Ekonomik segment',
      'Ankara merkez'
    ],
    tips: [
      { title: 'THY Bağlantısı', desc: 'THY standartları geçerli. Kalite beklentisi aynı.' },
      { title: 'İç Hat Odak', desc: 'Türkiye\'nin şehirlerini, kültürünü bilin.' },
      { title: 'Fiyat Avantajı', desc: 'Ekonomik fiyat ama THY kalitesi.' },
      { title: 'Kariyer Fırsatı', desc: 'AnadoluJet\'ten THY\'ye geçiş mümkün.' },
      { title: 'Esneklik', desc: 'Farklı şehirlere atanabilirsiniz.' }
    ],
    doNot: [
      'AnadoluJet\'i THY\'nin "küçük kardeşi" olarak görmeyin',
      'İç hatlarda çalışmayı küçümsemeyin',
      'THY\'ye geçiş garantisi beklemeyin'
    ]
  },
  {
    id: 'corendon',
    name: 'Corendon Airlines',
    emoji: '🌴',
    color: 'from-orange-500 to-red-500',
    slogan: 'Tatil Havayolu',
    keyFacts: [
      'Hollanda merkezli',
      'Antalya odaklı',
      'Tatil charter uçuşları',
      'Avrupa-Türkiye hatları'
    ],
    tips: [
      { title: 'Tatil Konsepti', desc: 'Yolcular tatil modunda. Neşeli ve sabırlı olmak kritik.' },
      { title: 'Çok Uluslu', desc: 'Hollanda, Belçika, Almanya uçuşları. Farklı milletlerle çalışma.' },
      { title: 'Antalya Bilgisi', desc: 'Antalya ve çevresi turistik bilgi avantaj sağlar.' },
      { title: 'Mevsimsellik', desc: 'Yaz sezonu yoğun. Esnek çalışma gerekir.' },
      { title: 'İngilizce + Diğer', desc: 'Hollandaca veya Almanca artı puan.' }
    ],
    doNot: [
      'Sadece sezonluk iş olarak görmeyin',
      'Charter uçuşları küçümsemeyin',
      'Turistlerle çalışmayı hafife almayın'
    ]
  }
];

export default function InterviewTips({ onBack }) {
  const [selectedAirline, setSelectedAirline] = useState(null);

  // Airline selection
  if (!selectedAirline) {
    return (
      <div className="min-h-screen bg-gray-50 pb-8">
        <div className="bg-gradient-to-br from-yellow-500 to-amber-600 px-4 pt-6 pb-8 rounded-b-[2rem]">
          <div className="max-w-4xl mx-auto">
            <button 
              onClick={onBack}
              className="flex items-center gap-2 text-white/80 hover:text-white mb-4"
            >
              <Home className="w-5 h-5" />
              <span className="font-medium">Pratik Merkezi</span>
            </button>
            
            <div className="text-center text-white">
              <Lightbulb className="w-12 h-12 mx-auto mb-2 text-yellow-200" />
              <h1 className="text-2xl font-bold">Havayolu İpuçları</h1>
              <p className="text-yellow-100 text-sm mt-1">Her havayolu için özel tavsiyeler</p>
            </div>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 mt-6">
          <div className="grid grid-cols-2 gap-4">
            {airlineTips.map((airline) => (
              <Card 
                key={airline.id}
                className="cursor-pointer hover:shadow-lg transition-all hover:scale-[1.02]"
                onClick={() => setSelectedAirline(airline.id)}
              >
                <CardContent className="p-4 text-center">
                  <div className={`w-16 h-16 mx-auto rounded-full bg-gradient-to-br ${airline.color} flex items-center justify-center mb-3`}>
                    <span className="text-3xl">{airline.emoji}</span>
                  </div>
                  <h3 className="font-bold text-gray-900">{airline.name}</h3>
                  <p className="text-sm text-gray-500 mt-1">{airline.tips.length} ipucu</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Airline detail
  const airline = airlineTips.find(a => a.id === selectedAirline);

  return (
    <div className="min-h-screen bg-gray-50 pb-8">
      <div className={`bg-gradient-to-br ${airline.color} px-4 pt-6 pb-8 rounded-b-[2rem]`}>
        <div className="max-w-4xl mx-auto">
          <button 
            onClick={() => setSelectedAirline(null)}
            className="flex items-center gap-2 text-white/80 hover:text-white mb-4"
          >
            <Home className="w-5 h-5" />
            <span className="font-medium">Pratik Merkezi</span>
          </button>
          
          <div className="text-center text-white">
            <span className="text-5xl mb-2 block">{airline.emoji}</span>
            <h1 className="text-2xl font-bold">{airline.name}</h1>
            <p className="text-white/80 text-sm mt-1 italic">"{airline.slogan}"</p>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 mt-6 space-y-4">
        {/* Key Facts */}
        <Card>
          <CardContent className="p-4">
            <h3 className="font-bold text-gray-800 mb-3 flex items-center gap-2">
              <Globe className="w-5 h-5 text-blue-600" />
              Temel Bilgiler
            </h3>
            <div className="grid grid-cols-2 gap-2">
              {airline.keyFacts.map((fact, i) => (
                <div key={i} className="flex items-center gap-2 text-sm text-gray-700">
                  <Star className="w-4 h-4 text-yellow-500" />
                  {fact}
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* Tips */}
        <Card>
          <CardContent className="p-4">
            <h3 className="font-bold text-gray-800 mb-3 flex items-center gap-2">
              <Lightbulb className="w-5 h-5 text-yellow-600" />
              Mülakat İpuçları
            </h3>
            <div className="space-y-3">
              {airline.tips.map((tip, i) => (
                <div key={i} className="bg-green-50 rounded-lg p-3">
                  <div className="flex items-start gap-2">
                    <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="font-medium text-green-800">{tip.title}</p>
                      <p className="text-sm text-gray-700 mt-0.5">{tip.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* Do Not */}
        <Card className="border-red-200">
          <CardContent className="p-4">
            <h3 className="font-bold text-red-800 mb-3 flex items-center gap-2">
              <AlertTriangle className="w-5 h-5 text-red-600" />
              Bunları Yapmayın
            </h3>
            <div className="space-y-2">
              {airline.doNot.map((item, i) => (
                <div key={i} className="flex items-start gap-2 text-sm text-red-700">
                  <span className="text-red-500 font-bold">✕</span>
                  {item}
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
